module.exports = __webpack_public_path__ + "img/03-2-3模型设计.c62b0ce9.svg";